import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { observer } from 'mobx-react-lite';
import { ThemeProvider as SCThemeProvider } from 'styled-components';

import { ThemeProvider } from '@components/theme-provider';
import { TooltipStyles } from '@components/tooltip';
import { GoogleAnalyticsHandler } from '@hooks/use-google-analytics';
import { DatePickerStyles } from '@styles/datepicker';

import { useTranslations } from 'locale';

import { Authenticated } from 'components/Authenticated';
import { GlobalStyles } from 'components/GlobalStyles';
import { AuthenticationProvider } from 'features/authentication';
import { useSessionResetOn503 } from 'features/maintenance';
import { SeasonalThemeProvider } from 'features/seasonal-theme';
import { Provider } from 'models/Provider';
import { RootStore } from 'models/RootStore';

import history, { BrowserRouter } from '../routing/history';
import { theme } from '../theme';

const rootStore = new RootStore({ history, theme });

window.root = rootStore;

export const App = observer(() => {
  useSessionResetOn503();
  useTranslations();
  return (
    <ThemeProvider app="hire">
      <Provider store={rootStore}>
        <BrowserRouter>
          <GoogleAnalyticsHandler />
          <SCThemeProvider theme={theme}>
            <SeasonalThemeProvider>
              <DatePickerStyles />
              <GlobalStyles />
              <TooltipStyles />
              <ScrollToTop />
              <AuthenticationProvider rootStore={rootStore}>
                <Authenticated />
              </AuthenticationProvider>
            </SeasonalThemeProvider>
          </SCThemeProvider>
        </BrowserRouter>
      </Provider>
    </ThemeProvider>
  );
});

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
}
